import { config } from '@services/config';
import { QuoteGetResponse } from '@lio/api-types';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';
import { quoteQueryKey } from '@services/quotes/keys';

export const useQuote = (quoteId: string | undefined) => {
  const client = useClient();

  const result = useQuery<QuoteGetResponse, Error>({
    queryKey: quoteQueryKey.get(quoteId),
    queryFn: async () => {
      const response = await client.get(`quote/${quoteId}`).json<QuoteGetResponse>();
      return response;
    },
    enabled: !!quoteId,
    retry: false,
    ...config,
  });
  return { ...result, quote: result.data };
};
